/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.account.departments.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.factory.gridState'
])

.controller('AccountDepartmentsController', ['$scope', '$timeout', '$uibModal', 'ApiService', 'PermissionsService', 'GridStateFactory', function($scope, $timeout, $uibModal, ApiService, PermissionsService, GridStateFactory) {

    $scope.accountDepartments = {

      model: [],

      isLoaded: false,

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        showFooter: true,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
            field: 'id',
            displayName: 'ID',
            visible: false
          },
          {
            field: 'name',
            displayName: 'name',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true,
            enableCellEditOnFocus: true
          },
          {
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.accountDepartments.remove(row.entity.id);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove</a></div>'
          }
        ]
      },
      
      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Departments Manager',
          buttonRight: {
            permissions: 'DEPT_CREATE',
            label: '+ Add Department',
            action: function () {
              $scope.accountDepartments.addDepartment();
            }
          }
        });

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getDepartments();
      },

      getDepartments: function() {
        ApiService.departments.list(this.gridState.getGridState()).then(this.success.getDepartments, this.error.getDepartments);
      },

      update: function(department) {
        var self = $scope.accountDepartments;
        console.log('AccountDepartmentsController::update', department);
        if (department.name.length > 0) {
          ApiService.departments.update(department).then(self.success.update, self.error.update);
        }
      },

      remove: function(id) {
        var self = $scope.accountDepartments;
        if (id) {
          ApiService.departments.remove(id).then(function() {
            self.getDepartments();
          }, self.error.remove);
        }
      },

      create: function() {
        if (this.currentDepartment.hasOwnProperty('name') && this.currentDepartment.name.length > 0) {
          ApiService.departments.create(this.currentDepartment)
          .then(function () {
            $scope.accountDepartments.getDepartments();
          }, this.error.create);
        }
      },

      hasDepartments: function() {
        return (this.model instanceof Array && this.model.length > 0);
      },

      addDepartment: function() {

        var self = $scope.accountDepartments;

        self.addModal = $uibModal.open({
          templateUrl: 'common/includes/createDepartmentModal.tpl.html',
          controller: ['$scope', '$uibModalInstance', 'ValidateService', 'NoticeFactory', function ($scope, $uibModalInstance, ValidateService, NoticeFactory) {

            $scope.isSubmitted = false;

            // Populate possible values to the model for use in modal
            $scope.model = {
              name: '',
              description: ''
            };

            $scope.errors = [];

            $scope.isValidName = function() {
              var r = true;
              if ($scope.isSubmitted) {
                r = ValidateService.validate([
                  { len: { value: $scope.model.name } }
                ]);
              }

              return r;
            };

            $scope.hasErrors = function () {
              return ($scope.errors.length > 0);
            };

            $scope.done = function () {

              $scope.isSubmitted = true;
              if (ValidateService.validate([
                { len: { value: $scope.model.name } }
              ])) {
                $scope.success($scope.model);
              }else{
                $scope.errors = [{
                  message: 'Please correct the errors below'
                }];
              }
            };

            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            $scope.success = function (response) {
              $uibModalInstance.close(response);
            };

          }]
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (department) {

          self.currentDepartment = department;
          self.create();

        }, function () {
          // Do nothing
        });
      },
      
      success: {
        create: function(response) {
          $scope.accountDepartments.currentDepartment = response.data.payload;
          $scope.accountDepartments.model.push($scope.accountDepartments.currentDepartment);
          $scope.accountDepartments.currentDepartment = {};
        },

        remove: function(response) {

        },

        update: function(response) {

        },

        getDepartments: function(response) {
          var self = $scope.accountDepartments;
          self.model = response.data.payload.list;
          //next tick
          $timeout(function() {
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
            self.isLoaded = true;
          }, 0);
        }
      },

      error: {
        create: function(response) {
          //TODO: Implement
        },

        remove: function(response) {
          //TODO: Implement
        },

        update: function(response) {
          //TODO: Implement
        },

        getDepartments: function(response) {
          //TODO: Implement
        }
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.accountDepartments;
        self.gridState.updateGridState(newPage, pageSize);
        self.getDepartments();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.accountDepartments, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getDepartments();
        }
      }

    };

    $scope.accountDepartments.init();

}]);